import Avatar from "../UI/Avatar";
import Breadcrumb from "../UI/Breadcrumb";
import Title from "../UI/Title";
import styles from "./HeaderProfileBailleur.module.css";
import { getInitialsFromName } from "./profileUtils";
import VideoTutorialsButton from "../VideoTutorials/VideoTutorialsButton";
import useActiveTab from "../../hooks/use-active-tab";

interface HeaderProfileBailleurProps {
  profileBailleur: { nom_profile: string };
}

export default function HeaderProfileBailleur({
  profileBailleur,
}: HeaderProfileBailleurProps) {
  const initials = getInitialsFromName(profileBailleur.nom_profile);
  const activeTab = useActiveTab("bailleur-show", "vue-ensemble");

  return (
    <div className={styles.header}>
      <div className={styles.breadcrumb}>
        <Breadcrumb
          items={[
            { label: "Tableau de bord", to: "/bailleur" },
            { label: "Bailleurs", to: "/bailleur/profiles" },
            { label: profileBailleur.nom_profile },
          ]}
        />
      </div>
      <div className={styles.background}></div>

      <div className={styles.profileSection}>
        <Avatar initials={initials} size="lg" variant="yellow" />

        <div className={styles.titleRow}>
          <Title variant="hecto" weight="bold">
            {profileBailleur.nom_profile}
          </Title>
          {activeTab === "vue-ensemble" && (
            <VideoTutorialsButton page="bailleur" />
          )}
        </div>
      </div>
    </div>
  );
}
